import { render, staticRenderFns } from "./InstructionDocumentFile.vue?vue&type=template&id=59a5c94e&"
import script from "./InstructionDocumentFile.vue?vue&type=script&lang=js&"
export * from "./InstructionDocumentFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports